export const ROUTE_PREFIX = '';

export const TOAST_AUTO_CLOSE = false;
export const TOAST_POSITION = 'top-center';

export const PAYMENT_STATUS_PAID = 'PAID';
export const ACCESS_DENIED_CODE = '401';

export const TOKEN = 'token';
export const EV_CHARGING_CONST = 'evCharging';
export const STANDARD_SHOP_CONST = 'standardShop';

export const SWISH_TIMEOUT_MSG = 'Swish payment timed out.';

export const REQUIRED = (resource) => `${resource} is required!`;

export const MAIN_ROUTE = (quickshopId) => `${ROUTE_PREFIX}/qs/${quickshopId}`;
export const CHECKOUT_SUCCESS_ROUTE = (quickshopId) => `${ROUTE_PREFIX}/qs/${quickshopId}/checkout-success`;
export const CHECKOUT_FAILED_ROUTE = (quickshopId) => `${ROUTE_PREFIX}/qs/${quickshopId}/checkout-failed`;

export const LANGUAGES = [
  { value: 'sv-SE', label: 'Swedish', image: 'img/languages/swedish.svg', code: 'sv' },
  { value: 'en-US', label: 'English', image: 'img/languages/english.svg', code: 'en' },
  { value: 'no-NO', label: 'Norwegian', image: 'img/languages/norwegian.svg', code: 'no' },
  { value: 'da-DAN', label: 'Danish', image: 'img/languages/danish.svg', code: 'da' },
];

export const PREFERRED_COUNTRIES = ['se', 'dk', 'no', 'fi', 'ie', 'gb'];

export const COUNTRIES_EXTN = [
  { code: 'se', name: 'Sweden', extn: '+46' },
  { code: 'dk', name: 'Denmark', extn: '+45' },
  { code: 'no', name: 'Norway', extn: '+47' },
  { code: 'fi', name: 'Finland', extn: '+358' },
  { code: 'de', name: 'Germany', extn: '+49' },
  { code: 'fr', name: 'France', extn: '+33' },
  { code: 'es', name: 'Spain', extn: '+34' },
  { code: 'ee', name: 'Estonia', extn: '+372' },
  { code: 'pl', name: 'Poland', extn: '+48' },
  { code: 'nl', name: 'Netherlands', extn: '+31' },
  { code: 'at', name: 'Austria', extn: '+43' },
  { code: 'ie', name: 'Ireland', extn: '+353' },
  { code: 'cy', name: 'Cyprus', extn: '+357' },
  { code: 'lv', name: 'Latvia', extn: '+371' },
  { code: 'lu', name: 'Luxembourg', extn: '+352' },
  { code: 'pt', name: 'Portugal', extn: '+351' },
  { code: 'sk', name: 'Slovakia', extn: '+421' },
  { code: 'si', name: 'Slovenia', extn: '+386' },
  { code: 'gr', name: 'Greece', extn: '+30' },
  { code: 'mt', name: 'Malta', extn: '+356' },
  { code: 'it', name: 'Italy', extn: '+39' },
  { code: 'mx', name: 'Mexico', extn: '+52' },
  { code: 'gb', name: 'United Kingdom', extn: '+44' },
];

export const PRICE_TYPE_EV_CHARGING_BASIC = 'evChargingBasic';
export const LINE_ITEM_CATEGORY_GENERAL = 'general';
export const LINE_ITEM_CATEGORY_RESTRICTIONS = 'restrictions';
export const LINE_ITEM_CATEGORY_PAYMENT_METHODS = 'paymentMethods';

export const QUICKSHOP_PUBLIC_USE = 'publicUse';
export const QUICKSHOP_PRIVATE_USE = 'privateUse';
export const QUICKSHOP_RENTAL_PUBLIC_USE = 'rentalPublicUse';
export const QUICKSHOP_RENTAL_PRIVATE_USE = 'rentalPrivateUser';

export const STATUS_WAITING_FOR_PAYMENT = 'waitingforpayment';
export const STATUS_PAID = 'paid';

export const ENGLISH_LANG_SHORT = 'en-US';
export const SWEDISH_LANG_SHORT = 'sv-SE';
export const NORWEGIAN_LANG_SHORT = 'no-NO';

export const ENGLISH_LANG = 'en';
export const NORWEGIAN_LANG = 'no';
export const SWEDISH_LANG = 'sv';

export const SWISH_STATUS_PENDING = 'pending';
export const SWISH_STATUS_FAILED = 'denied';
export const SWISH_STATUS_SUCCESS = 'paid';

export const STATUS_CODE_AVAILABLE = 'available';
export const STATUS_CODE_OUT_OF_SERVICE = 'outOfService';
export const STATUS_CODE_OCCUPIED = 'occupied';
export const STATUS_CODE_CHARGING = 'charging';
export const STATUS_CODE_BOOKED = 'booked';
export const STATUS_CODE_FINISHING = 'finishing';
export const STATUS_CODE_PREPARING = 'preparing';
export const STATUS_CODE_SUSPENDEDEVSE = 'suspendedevse';
export const STATUS_CODE_SUSPENDEDDEV = 'suspendedev';
export const STATUS_CODE_RESERVED = 'reserved';
export const STATUS_CODE_UNAVAILABLE = 'unavailable';
export const STATUS_CODE_FAULTED = 'faulted';

export const STRIPE_STATUS_SUCCEEDED = 'succeeded';
export const STRIPE_STATUS_PROCESSING = 'processing';
export const STRIPE_STATUS_REQUIRES_CAPTURE = 'requires_capture';
export const STRIPE_STATUS_REQUIRES_PAYMENT_METHOD = 'requires_payment_method';

export const QUICKSHOP_ROUTE = (id) => `/qs/${id}`;

export const QUICKSHOP_RENTAL_ROUTE = (id) => `/rental/${id}`;

export const PSP_TYPE_STRIPE = 'stripe';
export const PSP_TYPE_SWISH = 'swish';

export const PSP_TYPE_TEXT_CREDIT_CARD = 'Card or Wallet';
export const PSP_TYPE_TEXT_SWISH = 'Swish';

export const SESSION_STATUS_STARTED = 'started';
export const SESSION_STATUS_STOPPING = 'stopping';
export const SESSION_STATUS_STOPPED = 'stopped';

export const CONST_BANKGIRO = 'bankgiro';
export const CONST_IBAN = 'iban';

export const CUSTOMER_PRIVACY_NOTICE_URL = 'https://new.abb.com/privacy-notice/customer';
